import { render, staticRenderFns } from "./NsCedynaForm.vue?vue&type=template&id=4c70e207&scoped=true&"
import script from "./NsCedynaForm.vue?vue&type=script&lang=js&"
export * from "./NsCedynaForm.vue?vue&type=script&lang=js&"
import style0 from "./NsCedynaForm.vue?vue&type=style&index=0&id=4c70e207&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c70e207",
  null
  
)

export default component.exports